module.exports = __webpack_public_path__ + "static/media/bomb.667e7d68.svg";